import * as React from "react";
import type { SVGProps } from "react";
const SvgClockWatch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    viewBox="0 0 17 16" {...props}
  >
    <circle
      cx={8.9}
      cy={7.999}
      r={6.003}
      stroke="#EE2049"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      stroke="#EE2049"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.203 8.767 8.899 8V3.998"
    />
  </svg>
);
export default SvgClockWatch;
